<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12 sm12>
        <v-toolbar class="elevation-2">
          <v-row dense class="mt-3 pt-3">
            <v-col cols="12" sm="6" md="4">
              <SelectedGroupDinamicField :itemAction="selectedPeriodos" :on-success="actionFieldData" />
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-toolbar>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="object" :urls="url" :message="message" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'asist.resumenhoras-create' },
          { title: 'Importar', icon: 'mdi-database-import', color: 'blue-grey darken-1', action: 'importData', code: 'asist.resumenhoras-create-layout' }
        ],
        titles: [
          { text: 'Cve Empleado', value: 'adscripcion.empleado.cve_empleado', class: 'black--text' },
          { text: 'Nombre Empleado', value: 'adscripcion.empleado.NombreCompleto', class: 'black--text' },
          { text: 'Depto/Plantel', value: 'adscripcion.departamento.nombre', class: 'black--text' },
          { text: 'Plaza', value: 'adscripcion.plaza.nombre', class: 'black--text' },
          { text: 'Asistencias', value: 'FieldDinamicData', class: 'black--text', action: 'AsistenciaHorasFaltas', field: 'horas_asistencia' },
          { text: 'Faltas', value: 'FieldDinamicData', class: 'black--text', action: 'AsistenciaHorasFaltas', field: 'horas_faltas' },
          { text: 'Periodo', value: 'periodo.descripcion', class: 'black--text' },
          { text: 'Aplicado', value: 'FieldDinamicDataChip', action: 'ProcesadoAsistencias', field: 'procesado', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateData', code: 'asist.resumenhoras-create' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-3', action: 'deleteData', code: 'asist.resumenhoras-delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    selectedPeriodos: {
      field: 'selectGroupDataServer',
      name: 'Periodos',
      nameid: 'ejercicio_id',
      url: '/nomina/config/ejercicio/periodos',
      rules: true,
      default: true,
      cols: 12
    },
    params: {},
    form: [],
    object: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog,
    SelectedGroupDinamicField
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/asistencia/resumen-horas/show')
    },
    newData (item) {
      this.form = this.get_incidencia_form
      this.object = {}
      this.url = this.get_urls['POST/asistencia/resumen-horas/new']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nueva Incidencia' })
    },
    importData (item) {
      this.object = {}
      this.form = this.get_fileIncidencia
      this.url = this.get_urls['POST/asistencia/resumen-horas/importar']
      this.message = 'Importacion Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'fileSend', with: 950, title: 'Importar Incidencia', body: { content: 'form-data' } })
    },
    tableAction (item) {
      this[item.action](item.item)
    },
    updateData (item) {
      if (item.especial.procesado) {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'El horario no se puede modificar ya esta procesado a la nomina'
        })
        return
      }
      this.form = this.get_incidencia_form
      this.object = item
      this.url = this.get_urls['POST/asistencia/resumen-horas/new']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Actualizar Incidencia' })
    },
    deleteData (item) {
      /*
      if (item.especial.procesado) {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'El horario no se puede Eliminar ya esta procesado a la nomina'
        })
        return
      }
      */
      this.$swal.fire({
        title: 'Estas seguro de Eliminar el registro ?',
        message: 'No podras revertir el movimiento',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar !',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const url = this.get_urls['DELETE/asistencia/resumen-horas/delete/{id}']
          // console.log('url', url)
          this.deleteServiceAction({ url: url, params: item.id, replace: '{id}' })
        }
      })
    },
    ...mapActions(['getUrlServices', 'postServiceListAction', 'deleteServiceAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    actionFieldData (obj) {
      this.params.ejercicio_id = obj.data
      this.getUrl('POST/asistencia/resumen-horas/show')
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])

  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_incidencia_form', 'get_fileIncidencia', 'get_objects', 'get_objectDelete'])
  },
  watch: {
    get_urls (val) {
      this.getUrl('POST/asistencia/resumen-horas/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    },
    get_objectDelete (val) {
      if (val) {
        this.table.header.loading = true
        this.getUrl('POST/asistencia/resumen-horas/show')
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }
}
</script>

<style>

</style>
